"use client";

import MediaTextCard from "@/components/common/media-text-card/media-text-card";
import { SectionHeader } from "@/components/common/section-header";
import { Box } from "@mui/material";
import React from "react";
import { MediaCard, MediaCardSection } from "@/types/dto/common/media-card-section";

interface BreakingMythsProps {
  breakingMythsData?: MediaCardSection;
  moduleRankingPosition: number;
}

const BreakingMyths = ({ breakingMythsData, moduleRankingPosition }: BreakingMythsProps) => (
  <Box
    component="section"
    data-module-name="Breaking Myths Section"
    data-parent-container-type="breaking-myths-section"
    data-module-ranking-position={moduleRankingPosition}
    data-ranking-algorithm="manual"
    data-track="visibility"
    data-testid="breaking-myths-section"
  >
    {breakingMythsData?.basicInfo && (
      <Box sx={{ textAlign: "center", gap: "0", marginTop: "6rem", marginBottom: "1rem" }}>
        <SectionHeader
          headerText={breakingMythsData.basicInfo.headerText}
          headerTestId="myth-section-header"
          copyTestId="myth-section-copy"
          headerSx={{ textAlign: "center", textTransform: "none", px: "2rem" }}
          copyText={breakingMythsData.basicInfo.copyText}
          copySx={{ margin:"0 auto", maxWidth: "75rem", px: "2rem", "& p": { margin: "0 !important" } }}
        />
      </Box>
    )}

    {breakingMythsData?.mediaCards?.map((card: MediaCard, index: number) => (
      <MediaTextCard
        testId={card.mediaCardId}
        key={card?.mediaCardId || index}
        index={index}      
        reverseDesktop={card?.design === "Text Left"}
        reverseMobile={false}
        card={card}
        slotProps={{
          header: {
            sx: {
              "&::after": {
                content: "''",
                position: "absolute",
                bottom: "-8px",
                left: 0,
                width: "70px",
                height: "6px",
                backgroundColor: "accent.gold",
                borderRadius: "3px"
              }
            }
          },
          container: {
            sx: {
              gap: "2.4rem"
            }
          },
          fullWidthContainer: {
            sx: {
              padding: {
                xs: "1.2rem 2.4rem",
                sm: "1.2rem 3.2rem",
                md: "1.2rem 3.2rem",
                lg: "3rem 10rem"
              }
            }
          },
          textContainer: {
            sx: {
              display: "flex",
              padding: {
                xs: "2rem",
                sm: "2.4rem",
                md: "2.4rem",
                lg: "6rem 4rem"
              },
              flexDirection: "column",
              alignItems: "flex-start",
              gap: { xs: "1.2rem", sm: "2.4rem" },
              flex: "1 0 0",
              backgroundColor: index % 2 === 0 ? "background.cool_strong" : "info.500",
              borderRadius: "2rem"
            }
          }
        }}
      />
    ))}
  </Box>
);

export default BreakingMyths;
